import { StorageItem } from "common/clients/storage/StorageItem/StorageItem";
import { DraftShippingPlanItem } from "inbounds/InboundTypes";

export const mapStorageItemToDraftShippingPlanItem = (storageItem: StorageItem): DraftShippingPlanItem => ({
  ...storageItem,
  numberOfCases: storageItem.expectedQty / (storageItem.caseQty ?? 1),
  qty: storageItem.expectedQty,
  caseQty: storageItem.caseQty ?? 1,
});
